import { Capacitor } from '@capacitor/core';

// The vessel invitation code from a share link — `/onboarding?code=VH-XXXX-XXXX`. Stored in
// sessionStorage (not router state) for the same reason as the referral code: it must survive
// the /onboarding → /auth → /sign-up trip, a reload, and the OAuth full-page redirect.
const KEY = 'onboarding:vessel-code';

export const VESSEL_CODE_PARAM = 'code';

// `VH-XXXX-XXXX` with some slack for how it is typed; anything longer is not a code.
const MAX_LENGTH = 32;

/**
 * The link an owner or captain passes on. The app's own origin is `capacitor://localhost` in the
 * native shell, which nobody else can open, so there the flavor's web host is used.
 */
export const vesselCodeLink = (code: string): string => {
  const origin = Capacitor.isNativePlatform()
    ? new URL(import.meta.env.VITE_API_URL).origin
    : window.location.origin;
  return `${origin}/onboarding?${VESSEL_CODE_PARAM}=${encodeURIComponent(code)}`;
};

/** Remembers the code a location search string carries, if any. */
export const captureVesselCode = (search: string) => {
  const code = new URLSearchParams(search).get(VESSEL_CODE_PARAM)?.trim() ?? '';
  if (code && code.length <= MAX_LENGTH) sessionStorage.setItem(KEY, code);
};

export const getVesselCode = (): string | null => sessionStorage.getItem(KEY);

/** Forgets the code once it has been tried, joined with or turned down. */
export const clearVesselCode = () => sessionStorage.removeItem(KEY);
